let cachedSupport: boolean | null = null;

/**
 * Three.js throws when it cannot create a context, so the canvas has to be kept
 * off the tree entirely on clients where WebGL is blocked, disabled, or missing.
 * The probe context is created once and released immediately.
 */
export function isWebGlAvailable(): boolean {
  if (cachedSupport !== null) {
    return cachedSupport;
  }

  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return false;
  }

  try {
    const canvas = document.createElement('canvas');
    const context =
      canvas.getContext('webgl2') ??
      canvas.getContext('webgl') ??
      canvas.getContext('experimental-webgl');

    cachedSupport = context !== null;

    if (context && 'getExtension' in context) {
      (context as WebGLRenderingContext).getExtension('WEBGL_lose_context')?.loseContext();
    }
  } catch {
    cachedSupport = false;
  }

  return cachedSupport;
}
